import React from "react"
import { Heading, Text } from "@chakra-ui/react"

type Props = {
  product: any
}

const ProductTitle: React.FC<Props> = ({ product }) => (
  <>
    <Heading as="h1" size="h3">
      {product?.title}
    </Heading>

    {product?.type && <Text fontWeight="semibold">{product.type}</Text>}
  </>
)

export default React.memo(ProductTitle)
